import { useCallback } from "react";
import { getTranslation } from "../i18n";
import { useLanguage } from "../context/LanguageContext";

export const useTranslation = () => {
  const { language } = useLanguage();

  const t = useCallback(
    (key) => getTranslation(language, key),
    [language]
  );

  return { t, language };
};
